<template>
  <div class="def-email" :class="{ 'def-email_transform': isTransform }">
    <input
      :id="id"
      type="text"
      class="def-email__input"
      :class="{ 'def-email__input_full': !label }"
      :value="value"
      :required="required"
      pattern="[A-Za-z0-9\._%+\-]+@[A-Za-z0-9\.\-]+\.[A-Za-z]{1,63}$"
      :form="form"
      :name="name"
      :disabled="disabled"
      @input="({ target }) => $emit('input', target.value)"
      @invalid.prevent="handlerInvalid"
      @blur="handlerBlur"
      @focus="handlerFocus"
      @change="$emit('change', $event)"
    />
    <label :for="id" class="def-email__label">{{ placeholder }}</label>
    <transition name="fade">
      <svg v-if="!isValid" class="def-email__icon-error">
        <use xlink:href="#svg-error-icon"></use>
      </svg>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'DefEmail',
  props: ['value', 'required', 'placeholder', 'form', 'name', 'disabled', 'id'],
  data() {
    return {
      isValid: true,
      localValue: this.value,
      isTransform: this.value?.length > 0,
    };
  },
  methods: {
    handlerInvalid(e) {
      const { target } = e;
      this.isValid = false;

      target.parentElement.classList.add('def-email__invalid');
      this.$emit('invalid', e);
    },
    handlerBlur(e) {
      const { target } = e;
      if (target.checkValidity()) {
        target.parentElement.classList.remove('def-email__invalid');
        this.isValid = true;
      }
      this.$emit('blur', e);
      if (target.value.length === 0) {
        this.isTransform = false;
      }
    },
    handlerFocus(e) {
      this.$emit('focus', e);
      this.isValid = true;
      this.isTransform = true;
    },
    handlerChange(e) {
      const { target } = e;

      if (target.checkValidity()) {
        target.parentElement.classList.remove('def-input__invalid');
        this.isValid = true;
      }

      this.localValue = target.value;
      this.isTransform = target.value.length > 0;
    },
  },
  /**
   * Данная маска не корректно работает с функцией checkValidity()
   */
  // async mounted() {
  //     const InputMask = await import(/* webpackChunkName: "input-mask" */ 'inputmask');
  //
  //     const email = new InputMask.default({
  //         mask: '*{1,20}[.*{1,20}][.*{1,20}][.*{1,20}]@{1}*{1,20}d{1}*{2,6}[.*{1,2}]',
  //         greedy: false,
  //         definitions: {
  //             '*': {
  //                 validator: "[0-9A-Za-z_-]",
  //                 cardinality: 1,
  //                 casing: "lower"
  //             },
  //             '@': {
  //                 validator: '@',
  //                 cardinality: 1,
  //                 casing: 'lower'
  //             },
  //             'd': {
  //                 validator: '.',
  //                 cardinality: 1,
  //                 casing: 'lower'
  //             }
  //         }
  //     });
  //     email.mask(this.$el.children);
  // }
};
</script>

<style lang="scss">
.def-email {
  position: relative;
  height: 56px;
  background-color: #fff;
  display: flex;
  align-items: flex-end;
  border: 1px solid #dfdfdf;
  &__input {
    width: 100%;
    padding: 16px 20px 0 16px;
    border: none;
    font-size: rem(16);
    font-weight: 500;
    text-transform: lowercase;
    height: 100%;
    @include point-md {
      font-size: rem(16);
    }

    &_full {
      margin-bottom: 0;
      height: 100%;
    }

    &::placeholder {
      color: #53595c;
    }

    &:focus {
      outline: none;
    }
  }
  &__label {
    position: absolute;
    top: 22px;
    transition: 0.2s linear top;
    font-size: 16px;
    color: #757575;
    left: 16px;
    font-weight: 400;

    &:first-letter {
      text-transform: uppercase;
    }
  }

  &_transform {
    .def-email__label {
      top: 6px;
      transform: translateY(0);
    }
  }
  &__invalid {
    border-color: #c0392b;
  }
  &__icon-error {
    position: absolute;
    top: 20px;
    right: 16px;
    fill: var(--background-red);
    width: 16px;
    height: 16px;
    pointer-events: none;
  }
}

//.def-input{
//    width: 100%;
//}
//.def-input-wrapper{
//    position: relative;
//}
//.def-input-error{
//    color: red;
//    position: absolute;
//    bottom: 0;
//    left: 19px;
//    font-size: rem(12);
//    transform: translateY(-100%);
//}
</style>
